import {ReloadButton} from '@flexinet/ui-components';
import {Box} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {testRunsKeys} from '../hooks/useTestRunsQuery';

// The ONLY button in this module. READ-ONLY (FNP-969): there is no Add, no Edit
// and no Delete, because openTestRun / closeTestRun / abandonTestRun are all
// @aws_iam and belong to the executor canary.
export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: testRunsKeys.all});
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
